// extracted by mini-css-extract-plugin
export var noLicensePage = "no-license-page_Y7j2e1RVlL7DjSAL_KBc";
export var noLicensePageWarningIcon = "no-license-page__warning-icon_YRGyaoJIF_EyhC9ZvnMx";